import React from 'react';
import {Link} from 'react-router-dom';
import Button from '../button';

class LinkButtonComponent extends React.Component {
    render() {
        const {to, type, full, title} = this.props;
        return (
            <Link to={to}>
                <Button type={type} full={full} title={title}/>
            </Link>
        );
    }
}

export default LinkButtonComponent;